<template>
	<div>
		<span class="filter-txt">预警信息</span>
		<el-select @change="change" size="medium" v-model="warn" :placeholder="tip">
			<el-option label="选择预警信息" ></el-option>
			<el-option :label="v.value" :value="v.warning" v-for="(v,k) in warns" :key="k"></el-option>
		</el-select>
	</div>
</template>

<script>
	import { warns } from '@/js/param'
	export default {
		data() {
			return {
				warns,
				tip:'选择预警信息',
				warn: '',
			}
		},
		created(){
		},
		methods: {
			change(val) {
				this.$emit('change', val)
			}
		},
		computed:{
			isChanged(a,b){
				return this.$store.state.common.biaotouName
			}
		},
		watch: {
			isChanged(a,b){
				if(this.$store.state.common.biaotouName){
					this.warn = ''
				}
			}
		}		
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/globle/warns.vue